export default "__VITE_ASSET__C0o0eWTO__";